import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import _WidgetBase from 'dijit/_WidgetBase';
import RequestManager from 'more/RequestManager';
import { compose, mdsWidget } from 'dojo/_base/declare';
import connect from 'dojo/_base/connect';
import { ExtraHelpers } from "../../../more/Helpers";
import methodHooks from 'more/mdsMethodHooks';

var $ = window["$"] as any; // jQuery bekannt machen. wir brauchen dafür keine types

class SignalR extends methodHooks(compose(_WidgetBase)) {

    autoConnectActive: boolean = true;
    protected _connectionStarted: boolean = false;
    protected _callsBeforeStarted: Array<any>;
    private _disconnectToastHandle: any = null;
    private _disconnectedShown: boolean = false;
    protected _topics: Array<any>;

    // The modern HubConnection (replaces $.connection.hub / $.connection.commandHub).
    protected _conn: any = null;
    // Server->client handlers registered via conn.on(name, handler); collected so subclasses
    // can add theirs in _additionalHubs before start (parity with the old client.onX mapping).
    protected _handlers: { [name: string]: (...args: any[]) => void } = {};

    // The sideloaded @microsoft/signalr library (window.signalRLib) — NOT window.signalR (= this widget).
    // NB: a TS `get` accessor does NOT survive dojo/_base/declare (the decorator copies own
    // members, not prototype accessors) → it read back undefined. Use a plain method instead.
    protected _signalrLib(): any { return (window as any).signalRLib; }

    protected _setupSubscriptions(): void {
        this._topics.push(topic.subscribe("/Session/NewSession", lang.hitch(this, this._onNewSession))); //
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //  hack um den "nicht authorisiert"-Fehler zu erkennen. jQuery-Requests auf Status 401 prüfen.
        if ($ && $.ajaxSetup) {
            $.ajaxSetup({
                statusCode: {
                    401: function () {
                        connect.publish("/RequestManager/SessionExpired", [{}]);
                    }
                }
            });
        }

        this._callsBeforeStarted = [];
        this._topics = [];

        this._setupSubscriptions();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    protected _onNewSession(): void {
        //  Wird ausgeführt sobald moreCore/System/Session/SessionINfo einen Login ausgeführt hat
        this.StartConnection();
    }


    // SignalR Logic starts here ----

    // manuell aufrufen nach instanzierung
    public StartConnection(): void {
        var req = new RequestManager();
        var url = window.appRoot + "session/GetActiveWebsocketCount";

        req.get(
            url,
            lang.hitch(this, this._connect),
            function (error) {
            },
            false // sync
        );
    }

    protected _connect(activeWebsocketConnections: Number): void {
        if (typeof (activeWebsocketConnections) != "undefined" && Number(activeWebsocketConnections) >= 5) {
            console.log("Das Limit für gleichzeit geöffnete Verbindungen wurde überschritten.");
            return; // man darf nur ~6 websocket connections (tabs) offen haben.
        }

        // Sideload @microsoft/signalr (own bundle → window.signalRLib), then wire + start.
        if (this._signalrLib()) {
            this._initAndStart();
            return;
        }

        var bundleUrl = window.appRoot + "lib/signalr/signalr.bundle.js";
        ExtraHelpers.sideLoadResource(bundleUrl, 'js')
            .then(lang.hitch(this, this._initAndStart))
            .catch(function (ex) {
                console.warn("Could not sideload @microsoft/signalr bundle", ex);
            });
    }

    protected _initAndStart(): void {
        if (!this._signalrLib()) {
            console.warn("signalRLib not available after sideload");
            return;
        }
        this._initHubs();
        this._startHub();
    }

    protected _initHubs(): void {
        //  Server -> Client Events registrieren (conn.on statt $.connection.commandHub.client.onX)
        this._handlers["onGlobalMessage"] = lang.hitch(this, this._onSignalR__GlobalMessage);
        this._handlers["onGetConnectedUsers"] = lang.hitch(this, this._onSignalR__GetConnectedUsers);
        this._handlers["onUserOnlineStateChanged"] = lang.hitch(this, this._onSignalR__UserOnlineStateChanged);
        this._handlers["onGetUserOnlineStateCallback"] = lang.hitch(this, this._onSignalR__UserOnlineStateChanged); // selbes Callback
        this._handlers["stopConnection"] = lang.hitch(this, this._onSignalR__StopConnection);
        this._handlers["onUserCommand"] = lang.hitch(this, this._onSignalR_onUserCommand);

        this._additionalHubs();
    }

    protected _additionalHubs(): void {
        // override this in subclass
    }

    protected _startHub(): void {
        if (this.autoConnectActive !== true) {
            return;
        }

        if (!window.sessionInfo || !window.sessionInfo.sessionData) {
            console.warn("cannot start SignalR-Hub without session - check window.sessionInfo");
            return;
        }

        var sid = window.sessionInfo.sessionData.Session.Id;
        var hubUrl = window.appRoot + "signalr/command?sid=" + encodeURIComponent(sid);

        var lib = this._signalrLib();
        this._conn = new lib.HubConnectionBuilder()
            .withUrl(hubUrl)
            .withAutomaticReconnect()
            .build();

        // Register all handlers before start.
        for (var name in this._handlers) {
            if (this._handlers.hasOwnProperty(name)) {
                this._conn.on(name, this._handlers[name]);
            }
        }

        this._conn.onreconnected(lang.hitch(this, this._onHubConnected));
        this._conn.onclose(lang.hitch(this, this._onHubDisconnected));

        this._conn.start()
            .then(lang.hitch(this, this._onHubStarted))
            .catch(lang.hitch(this, this._onHubError));

        //stoppen wenn hinter ms team tab app reverse-proxy.
        if (window.msTeamsSimpleApi && window.msTeamsSimpleApi.isCurrentlyRunningInTeamsTab == true) {
            this._conn.stop();
        }
        topic.subscribe("MsTeamsIntegration/Authenticated", lang.hitch(this, () => {
            console.info("signalR has been disabled for teams integration reverse-proxy");
            if (this._conn) this._conn.stop();
        }));
    }

    protected _onHubStarted(): void {
        this._connectionStarted = true;

        for (var i = 0; i < this._callsBeforeStarted.length; i++) {
            var func = this._callsBeforeStarted[i][0];
            var args = this._callsBeforeStarted[i][1];
            func.apply(this, args);
        }

        this._callsBeforeStarted = [];
    }


    protected _onHubError(error): void {
        console.warn("signalR hub error", error);
    }

    protected _onHubDisconnected(): void {
        this._connectionStarted = false;
        // withAutomaticReconnect handles retry; keep the toast-suppression bookkeeping.
        if (this._disconnectToastHandle != null) {
            clearTimeout(this._disconnectToastHandle);
            this._disconnectToastHandle = null;
        }
        this._disconnectToastHandle = setTimeout(lang.hitch(this, function () {
            this._disconnectToastHandle = null;
            this._disconnectedShown = true;
        }), 6666);
    }

    protected _onHubConnected(): void {
        this._connectionStarted = true;
        if (this._disconnectToastHandle != null) {
            clearTimeout(this._disconnectToastHandle);
            this._disconnectToastHandle = null;
        }
        this._disconnectedShown = false;
    }

    protected _onSignalR__StopConnection(): void {
        if (this._conn) this._conn.stop();
    }

    // Empfangen Server -> Cient
    protected _onSignalR__GlobalMessage(message: string) {
        connect.publish("/MainForm/showToastMessage", [message, "far fa-comment", { close: true, timeout: 0 }]);

        this.showToast({
            title: "Received Message!",
            iconClass: "far fa-envelope",
            message: message,
            options: {
                closeButton: true,
                timeout: -1
            }
        });

        console.log("%cGlobalMessage", "color:yellow;background-color:blue", message);
    }

    protected _onSignalR__GetConnectedUsers(users: any) {
        console.debug("signalR _onSignalR__GetConnectedUsers", users);
        this.showToast({
            title: "connected users",
            iconClass: "fas fa-user",
            message: users,
            options: {
                closeButton: true,
                timeout: 15000
            }
        });
    }

    protected _onSignalR__UserOnlineStateChanged(userid: string, online: boolean) {
        connect.publish("/user/onlinestate", [userid, online]);
    }

    protected _onSignalR_onUserCommand(command: any, data: any) {
        //  auf üblichem CommandStack veröffentlichen
        connect.publish("CommandStack", [{ "command": command, "data": JSON.stringify(data) }]);
    }

    protected showToast(config: GlobalToastConfig): void {
        if (!config) return null;
        topic.publish("/Toaster/ShowToast", config);
    };
    protected removeToast(toastID: string): void {
        topic.publish("/Toaster/RemoveToast", toastID);
    };


    //  Senden Client => Server
    public Disconnect() {
        try {
            if (this._conn) this._conn.stop();
        } catch (error) {
            console.log(error);
        }
    }

    protected _invoke(method: string, ...args: any[]): void {
        if (this._connectionStarted != true || !this._conn) {
            this._callsBeforeStarted.push([lang.hitch(this, function () { this._invoke(method, ...args); }), []]);
        } else {
            this._conn.invoke(method, ...args).catch(function (ex) {
                console.warn("signalR invoke failed: " + method, ex);
            });
        }
    }

    public SendGlobalMessage(message) {
        this._invoke("SendGlobalMessage", message);
    }

    public GetConnectedUsers() {
        this._invoke("GetConnectedUsers");
    }

    public GetUserOnlineState(userid) {
        this._invoke("GetUserOnlineState", userid);
    }
}

export default mdsWidget(SignalR);
